import React from 'react'
import ShiftList from '../components/ShiftManagement/ShiftList'

export default function ShiftManagement() {
  return (
    <div>
      <ShiftList />
    </div>
  )
}
